import moment from "moment";
import { MULTITENANT_CONSTANTS, TENANT } from "../../Resources/Multitenant/tenantConstants";

export const STATE_LIVE = "live";
export const STATE_UPCOMING = "upcoming";
export const STATE_DEFERRED = "deferred";
export const STATE_SUMMARY = "summary";

const DEFAULT_LIVE_DURATION_SECONDS = 2 * 60 * 60;
const SUMMARY_PREFIX = /^resumen\s+/i;

const hasLiveType = (w) => `${w?.type ?? ""}`.toLowerCase().includes("live");

export const getStartSeconds = (w) => {
  if (w?.start) return Number(w.start);
  if (w?.publish_date) {
    const m = moment(w.publish_date);
    if (m.isValid()) return m.unix();
  }
  return null;
};

const isSummary = (w) =>
  SUMMARY_PREFIX.test(`${w?.title ?? ""}`) ||
  (w?.tags ?? []).some((tag) => `${tag?.name ?? tag?.code ?? tag}`.toLowerCase() === "resumen");

export const getContentState = (w, nowSeconds = Math.floor(Date.now() / 1000)) => {
  if (hasLiveType(w)) {
    const start = Number(w.start);
    const finish = w.finish ? Number(w.finish) : start + DEFAULT_LIVE_DURATION_SECONDS;
    if (nowSeconds < start) return STATE_UPCOMING;
    if (nowSeconds < finish) return STATE_LIVE;
  }
  return isSummary(w) ? STATE_SUMMARY : STATE_DEFERRED;
};

export const splitVsTitle = (rawTitle) => {
  const title = `${rawTitle ?? ""}`.replace(SUMMARY_PREFIX, "").trim();
  const vs = title.split(/\s+vs\.?\s+/i);
  if (vs.length === 2 && vs[0] && vs[1]) return [vs[0].trim(), vs[1].trim()];
  return null;
};

export const getCategoryName = (w, lang) => {
  const category = w?.category;
  if (!category || MULTITENANT_CONSTANTS[TENANT].hideCategory) return "";
  const tr = category.translations?.find((t) => t.language === lang);
  return tr?.name || tr?.code || category.name || category.code || "";
};

export const formatMeta = (w, state, lang) => {
  const start = getStartSeconds(w);
  let date = "";
  if (state === STATE_LIVE) {
    date = lang === "en" ? "Now" : lang === "ca" ? "Ara" : "Ahora";
  } else if (start) {
    const m = moment.unix(start).locale(lang);
    date = state === STATE_UPCOMING ? m.format("dddd DD/MM/YY · HH:mm") : m.format("DD/MM/YY");
    date = date.charAt(0).toUpperCase() + date.slice(1);
  }
  return [date, w?.rating?.code].filter(Boolean).join(" · ");
};
